<app-legacy-header></app-legacy-header>
<div id="home">
  <div class="video-slider videoBanner">
    <video loop id="my_video_1" playsinline="playsinline" onloadedmetadata="this.muted=true" preload="none"></video>
    <div
      [ngClass]="{
        'banner-text': language === 'en',
        'banner-text-fr': language === 'fr',
        'banner-text-de': language === 'de',
        'banner-text-it': language === 'it',
        'banner-text-es': language === 'es',
        'banner-text-pt': language === 'pt',
        'banner-text-ru': language === 'ru',
        'banner-text-zh': language === 'zh'
      }"
    >
      >
      <h1>Seychelles</h1>
    </div>

    <ul class="bannerIcons">
      <li class="slide-arrow right" (click)="nextPrevious(1)"></li>
      <li class="slide-arrow left" (click)="nextPrevious(-1)"></li>
    </ul>

    <div class="mouse_scroll" (click)="scollBottom()">
      <div class="mouse">
        <div class="wheel"></div>
      </div>
      <div>
        <span class="m_scroll_arrows unu"></span>
        <span class="m_scroll_arrows doi"></span>
        <span class="m_scroll_arrows trei"></span>
      </div>
    </div>
  </div>
  <div class="flex-container" style="margin-top: 8px">
    <div class="desktop">
      <div class="box box1">
        <img src="/assets/images/cellphone.png" class="box-img img1" alt="The Seychelles Islands mobile app" />
      </div>
      <div class="box box2">
        <img src="/assets/images/visit.png" class="box-img img2" style="min-width: 340px" alt="visit Seychelles" />
        <img src="/assets/images/pocket.png" class="box-img img3" style="max-width: 240px" alt="visit Seychelles " />
        <a href="https://mobile.seychelles.com/about" target="_blank" class="learnmore"> Learn More </a>
      </div>
      <div class="box box3">
        <img
          src="/assets/images/bannerlogo.png"
          class="box-img img4"
          style="max-width: 140px"
          alt="The Seychelles Islands"
        />
        <div style="display: flex">
          <div>
            <a href="https://play.google.com/store/apps/details?id=com.seychelles.android" target="_blank">
              <img
                src="/assets/images/playstore.png"
                class="box-img img6"
                style="cursor: pointer; max-width: 240px"
                alt="download The Seychelles Islands from playstore"
              />
            </a>
          </div>
          <div style="margin-left: 15px">
            <a
              style="margin-top: 10px"
              href="https://apps.apple.com/sc/app/visit-seychelles/id1663916867"
              target="_blank"
            >
              <img
                src="/assets/images/ios.png"
                class="box-img img6"
                style="cursor: pointer; max-width: 240px"
                alt="download The Seychelles Islands from App Store"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="arr">
        <div class="mbox box1">
          <img
            src="/assets/images/cellphone.png"
            class="box-img img1"
            style="max-width: 81%"
            alt="The Seychelles Islands mobile app"
          />
        </div>
        <div class="mbox box4" style="display: flex">
          <img src="/assets/images/bannerlogo.png" class="box-img img4" id="mobileimg4" alt="The Seychelles Islands" />
          <img src="/assets/images/visit.png" class="box-img img2" alt="visit Seychelles" />
          <img src="/assets/images/pocket.png" class="box-img img3 mobileimg3" id="mobileimg3" alt="visit Seychelles" />
          <a href="https://mobile.seychelles.com/about" target="_blank" class="learnmore-mobile"> Learn More </a>
          <div style="margin-top: 10px">
            <div style="display: flex; flex-direction: column; align-items: end">
              <a href="https://play.google.com/store/apps/details?id=com.seychelles.android" target="_blank">
                <img
                  src="/assets/images/playstore.png"
                  class="box-img"
                  style="cursor: pointer; max-width: 135px"
                  alt="download The Seychelles Islands from playstore"
                />
              </a>
              <a
                style="margin-top: 10px"
                href="https://apps.apple.com/sc/app/visit-seychelles/id1663916867"
                target="_blank"
              >
                <img
                  src="/assets/images/ios.png"
                  class="box-img"
                  style="cursor: pointer; max-width: 240px"
                  alt="download The Seychelles Islands from App Store"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-alert-popup></app-alert-popup>

  <div #categoriesContainer></div>
  <!-- <div #latestVideosContainer></div> -->
  <div #highlightsContainer></div>
  <div #testimonialContainer></div>
  <div #instagramContainer></div>
</div>
<app-legacy-footer></app-legacy-footer>
